<template>
  <div class="home-container">
    <Map :stationList="stationList"></Map>
    <!-- <TestMap></TestMap> -->
  </div>
</template>

<script>
import CardStation from '../components/CardStation.vue';
import Map from '../components/Map.vue';
import TestMap from '../components/TestMap.vue';

export default {
  name: 'Home',
  components: {
    CardStation,
    Map,
    TestMap
  },
  data() {
    return {
      stationList: [],
    };
  },
  methods: {
    async fetchData() {
      try {
        let response = await this.$apiFire('StationList/onGetStationList')
        console.log('apistation ', response);
        this.stationList = response;
        this.stationList = this.stationList.filter(station => {
          return station.status === '1';
        });
        // console.log('filtered stationList', this.stationList);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.fetchData();
  }
}
</script>

<style scoped>
* {
  --width-size: 150px;
  --height-size: 60px;
}

.home-container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: calc(100vh - 90px);
  /* z-index: 0; */
}

.search {
  width: 200px;
  background: palegreen;
  z-index: 10;
}
</style>
